import _taggedTemplateLiteral from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { Typography } from '@finam/web-ui-kit';
import styled from 'styled-components';
import Link from '../Core/Link';
export var Root = styled(Typography).attrs({
  variant: 'caption12',
  color: 'secondary'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-align: center;\n  margin-top: 16px;\n  padding: 8px 0;\n"])));
export var AgreementLink = styled(Link).attrs({
  typographyVariant: 'caption12'
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline;\n"])));